// extracted by mini-css-extract-plugin
export default {"text_land":"styles_text_land__elOaM"};